<template>
    <a class="btn btn-primary text-white d-flex align-items-center justify-content-center filter-button" 
        :class="{disabled: modelValue, large: isLarge, 'fs-6': isLarge}"
        @click="click"
    >
        <span v-if="text == ''">{{ $t('message.filter.search') }}</span>
        <span>{{ text }}</span>
        <span class="loader ms-3" v-if="modelValue"></span>
        <font-awesome-icon class="ms-3" :icon="['fas', 'search']" v-else-if="isIcon" />
    </a>
</template>

<script>
export default {
    name: 'FilterButton',
    emits: ['update:modelValue'],
    props: {
        text: {
            default: '',
            type: String
        },
        modelValue: {
            default: false,
            type: Boolean
        },
        isLarge: {
            default: false,
            type: Boolean
        },
        isIcon: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        click(){
            this.$emit('clickEvent');
        }
    },
}
</script>

<style scoped>
    .loader {
        width: 10px;
        height: 10px;
        border: 2px solid #FFF;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }

    .filter-button.large{
        width: 100%;
        height: 100%;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
</style>
